import { Trigger } from '@radix-ui/react-tabs'
import styled from 'styled-components'
import { BORDER_WIDTH, COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'

export const Tab = styled(Trigger)`
  flex: 1;
  padding: ${SPACE.PX_14} ${SPACE.PX_18};
  font-size: ${FONT_SIZE.PX_15};
  border-bottom: ${BORDER_WIDTH.PX_2} solid transparent;
  color: ${COLOR_INTENT.TABS.TAB.TEXT.BASE};
  &[data-state='active'] {
    border-bottom: ${BORDER_WIDTH.PX_2} solid ${COLOR_INTENT.TABS.BORDER.ACTIVE};
    color: ${COLOR_INTENT.TABS.TAB.TEXT.ACTIVE};
    font-weight: 500;
  }
`
